import React, { useState, useEffect } from 'react';
import hero1 from '../../assets/Hero/Hero1.webp';
import hero2 from '../../assets/Hero/Hero2.webp';
import hero3new from '../../assets/Hero/Hero3.webp';
import hero4 from '../../assets/Hero/Hero4.webp';
import hero5 from '../../assets/Hero/Hero5.webp';
import hero6 from '../../assets/Hero/Hero6.webp';
import hero7 from '../../assets/Hero/Hero7.webp';
import hero8 from '../../assets/Hero/Hero8.webp';
import hero9 from '../../assets/Hero/Hero9.webp';
import heroBodega from '../../assets/projects/BodegaServelec/img3.webp';
import heroGrupoQ from '../../assets/projects/GrupoQCeiba/Wh.webp';
import './CarouselBackground.css';

const SLIDES = [
  { url: hero1, alt: 'Obra Consuprog' },
  { url: heroGrupoQ, alt: 'Grupo Q La Ceiba' },
  { url: hero2, alt: 'Proyecto Consuprog' },
  { url: hero3new, alt: 'Construcción Consuprog' },
  { url: hero4, alt: 'Infraestructura Consuprog' },
  { url: hero5, alt: 'Ingeniería Consuprog' },
  { url: hero6, alt: 'Edificación Consuprog' },
  { url: hero7, alt: 'Supervisión Consuprog' },
  { url: hero8, alt: 'Obra civil Consuprog' },
  { url: hero9, alt: 'Proyecto Consuprog' },
  { url: heroBodega, alt: 'Complejo de Bodegas Servelec' },
];

const CarouselBackground = ({ overlayVariant = 'dark', showDots = false, interval = 5000 }) => {
  const [active, setActive] = useState(0);
  const [loaded, setLoaded] = useState(new Set([0]));

  useEffect(() => {
    const timer = setInterval(() => {
      setActive((prev) => {
        const next = (prev + 1) % SLIDES.length;
        setLoaded((l) => new Set([...l, next, (next + 1) % SLIDES.length]));
        return next;
      });
    }, interval);
    return () => clearInterval(timer);
  }, [interval]);

  return (
    <div className="carousel-bg">
      {SLIDES.map((slide, idx) => (
        <div
          key={idx}
          className={`carousel-bg__slide ${idx === active ? 'carousel-bg__slide--active' : ''}`}
          style={{ backgroundImage: loaded.has(idx) ? `url(${slide.url})` : undefined }}
          role="img"
          aria-label={slide.alt}
        />
      ))}
      <div className={`carousel-bg__overlay carousel-bg__overlay--${overlayVariant}`} />
      <div className="carousel-bg__overlay carousel-bg__overlay--bottom" />

      {showDots && (
        <div className="carousel-bg__dots">
          {SLIDES.map((_, idx) => (
            <button
              key={idx}
              className={`carousel-bg__dot ${idx === active ? 'carousel-bg__dot--active' : ''}`}
              onClick={() => setActive(idx)}
              aria-label={`Slide ${idx + 1}`}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default CarouselBackground;
